import { HTTP_INTERCEPTORS } from '@angular/common/http'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
// import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { SpartacusModule } from './spartacus/spartacus.module'
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CommonModule, DatePipe } from '@angular/common'
import { httpErrorInterceptors } from '@spartacus/core'
// import { VsOutletModule } from './shared/outlet/outlet.module'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { CartErrorInterceptor } from './shared/util/cart-not-found.interceptor'
import { CustomAuthInterceptor } from './shared/util/custom-auth.interceptor'
import { environment } from '../environments/environment'
import { AppRoutingModule } from '@spartacus/storefront'
import { VsGlobalMessageComponent } from './shared/components/global-message/global-message.component'
// import { ComponentLibraryModule } from '@bh-digital-solutions/ui-toolkit-angular/dist/'
import { ComponentLibraryWrapperModule } from './component-library-wrapper.module'
@NgModule({
  declarations: [AppComponent, VsGlobalMessageComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    // BrowserAnimationsModule,
    // VsOutletModule,
    ComponentLibraryWrapperModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CartErrorInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: CustomAuthInterceptor, multi: true },
    DatePipe,
    ...httpErrorInterceptors,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
